<template>
    <div class="issue-doctor-div">
        <a-select
            ref="doctorSelect"
            id="doctor"
            class="doctor-select"
            v-model:value="displayDoctor"
            @change="uiHandler.handleDoctorChange"
            :dropdown-style="{ zIndex: 1952 }"
        >
            <a-select-option 
                value="" 
                selected
            >
                의사 선택
            </a-select-option>
            <a-select-option 
                v-for="(doctor, index) in doctorList" 
                :key="index" 
                :value="doctor"
            >
                {{ doctor }}
            </a-select-option>
            <a-select-option 
                value="99"
            >
                직접입력
            </a-select-option>
        </a-select>
        <a-form-item-rest>
            <a-input
                :disabled="!isCustomDoctor"
                ref="customDoctorInput"
                type="text"
                v-model:value="customDoctorName"
                @input="uiHandler.updateCustomDoctorName"
                @compositionstart="uiHandler.onCompositionStart"
                @compositionend="uiHandler.onCompositionEnd"
            />
        </a-form-item-rest>
    </div>
</template>
<script>
export default {
    name: 'DoctorSelect',
    props: {
        value: String,
        doctorList: Array,
        isCustomDoctor: Boolean,
        language: String
    },
    emits: [
        'update:value', 
        'update:isCustomDoctor'
    ],
    data() {
        return {
            displayDoctor: this.isCustomDoctor ? '99' : this.value,
            customDoctorName: this.isCustomDoctor ? this.value : '',
            isComposing: false,
            uiHandler: this.createUiHandler(),
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                this.customDoctorName = newValue;
                if (this.isCustomDoctor) {
                    this.displayDoctor = '99';
                } else {
                    this.displayDoctor = newValue;
                }
            }
        },
        isCustomDoctor: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.displayDoctor = '99';
                } else {
                    this.displayDoctor = this.value;
                    this.customDoctorName = this.value;
                }
            }
        },
    },
    methods: {
        createUiHandler() {
            return {
                handleDoctorChange: (value) => {
                    if (value === '99') {
                        this.$emit('update:isCustomDoctor', true);
                        
                        this.$nextTick(() => {
                            this.customDoctorName = '';
                            this.$emit('update:value', '');
                            
                            if (this.$refs.customDoctorInput) {
                                this.$refs.customDoctorInput.focus();
                            }
                        });
                    } else {
                        this.$emit('update:isCustomDoctor', false);
                        this.$nextTick(() => {
                            this.customDoctorName = value;
                            this.$emit('update:value', value);
                        });
                    }
                },
                updateCustomDoctorName: (event) => {
                    if (this.isComposing) return;
                    this.customDoctorName = event.target.value;
                    if (this.isCustomDoctor) {
                        this.$emit('update:value', this.customDoctorName);
                    }
                },
                onCompositionStart: () => {
                    this.isComposing = true;
                },
                onCompositionEnd: () => {
                    this.isComposing = false;
                    this.$emit('update:value', this.customDoctorName);
                },
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.issue-doctor-div {
    display: flex;
    gap: 10px;
    flex: 1 0 0;
    input, div {
        flex: 1;
    }
}
</style>
